import React, { useEffect } from "react";
import { ScMarkup } from "./styled";
import { MarkupPanel } from "./MarkupPanel/MarkupPanel";
import { NavBar } from "./NavBar/NavBar";
import { MarkupControl } from "./MarkupControl/MarkupControl";
import { ContainerWide } from "./ContainerWide/ContainerWide";
import { MarkupSpace } from "./MarkupSpace/MarkupSpace";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  imageDataState,
  imageNameState,
  markupPathologyState,
  markupStepsState,
  pixelSpacingState,
} from "./markupAtoms";

interface MarkupProps {
  imageSrc: string;
  pixelSpacing: number;
  prevImage: () => void;
  nextImage: () => void;
}

export const Markup: React.FC<MarkupProps> = ({
  imageSrc,
  pixelSpacing,
  prevImage,
  nextImage,
}) => {
  const [, setPixelSpacing] = useRecoilState(pixelSpacingState);
  const setMarkupSteps = useSetRecoilState(markupStepsState);
  const [markupPathology] = useRecoilState(markupPathologyState);
  const [imageName] = useRecoilState(imageNameState);

  const [imageData, setImageData] = useRecoilState(imageDataState);

  useEffect(() => {
    if (!imageSrc) return;
    const img = new Image();
    img.onload = (e: any) => {
      const cW = e.target.width < 1048 ? 1 : 1048 / e.target.width;
      const cH = e.target.height < 516 ? 1 : 516 / e.target.height;

      const c = Math.min(cW, cH);

      setImageData({
        src: e.target.src,
        width: e.target.width * c,
        height: e.target.height * c,
        coefficient: c,
      });
      e.target.remove();
    };
    img.src = imageSrc;
  }, [imageSrc]);

  useEffect(() => {
    if (!imageData) return;

    setMarkupSteps([
      {
        step: "openMarkup",
        data: [...markupPathology[imageName]] || [],
      },
    ]);
  }, [imageData]);

  useEffect(() => {
    setPixelSpacing(pixelSpacing);
  }, [pixelSpacing]);

  return (
    <ScMarkup>
      <MarkupPanel />
      <div className="markup-container">
        <ContainerWide>
          <NavBar>
            <MarkupControl prevImage={prevImage} nextImage={nextImage} />
          </NavBar>
          <div className="space-container">
            {imageData && (
              <MarkupSpace
                imageSrc={imageData.src || ""}
                frameWidth={imageData.width || 0}
                frameHeight={imageData.height || 0}
                pixelSpacing={pixelSpacing}
              />
            )}
          </div>
        </ContainerWide>
      </div>
    </ScMarkup>
  );
};
